// extracted by mini-css-extract-plugin
module.exports = {"trim-mileage":"TrimMileage_trim-mileage__pjIo9","skeleton-trim":"TrimMileage_skeleton-trim__Waa9g"};